export default {
    data() {
        return {
            fullscreenLoading: false,
            //上传的文件
            fileListExcel: [],
            //上传文件的接口
            address: this.baseUrl + 'file/import_products?token=' + this.$store.state.authority_management,
            action: this.baseUrl + 'file/upload_img?token=' + this.$store.state.authority_management,
            creatFlag: '0',
            //图片唯一名
            image_data: '',

            form: {
                attr: '',
                cer_industry: null,
                cer_year: '',
                desc: '',
                id: '',
                //别名
                image: '',
                is_auth: '',
                name: '',
                onsale: '',
                period: '',
                price: '',
                project_id: '',
                shop_name: '',
                teacher: '',
                teacher_intro: '',
                page: '',
                label_name: '',
                label_id: '',
            },
            product_lablel_id: '',//产品标签连接表 id
            formCascader: [],
            project_name: [],
            //那一项数据
            flag: '',
            formLabelWidth: '120px',
            tableData: [{
                label_name: '',
            }],
            dialogFormVisible: false,
            multipleSelection: [],
            pages: [{
                value: '选项1',
                label: '项目式'
            },
                //  {
                // value: '选项2',
                // label: '项目式'
                // }
            ],
            classType: [{
                value: '选项1',
                label: '专业课'
            }, {
                value: '选项2',
                label: '选修课'
            }],
            classCertification: [{
                value: '1',
                label: '已认证'
            }, {
                value: '0',
                label: '未认证'
            }],
            totalProduct: 1,
            productLen: '15',
            offset: 0,
            currentPage: 1,
            totalPage: '',
            search: '',
            fileList: [{ name: '', url: '' }],
            //图片服务器地址
            imgBannerUrl: this.imgUrl,
            //图片上传
            imgName: '',
            dialogVisible: false,
            dialogFormRead: false,
            //标签
            labels: [
                {
                    id: '0',
                    name: '',
                    children: [

                    ]
                },
            ],
            labelsMap: [],
            props: {
                label: 'name',
                children: 'children',
                value: 'id'
            },
            selectedOptions: [],
            //筛选条件
            shelves: [{
                value: '0',
                label: '未上架'
            }, {
                value: '1',
                label: '已上架'
            }],
            certification: [{
                value: '0',
                label: '未认证'
            }, {
                value: '1',
                label: '已认证'
            }],
            cer_annual: [{
                value: '',
                label: '全年度',
            }],
            checkList: {
                onsale: '',
                is_auth: '',
                cer_year: '',
                teacher: '',
                name: '',
            },

            //项目式 数据
            itemList: [],
            itemOptions: [],
            itemCheck: {},
            // 地区选项
            regions: [
                {
                    value: '廉江',
                    label: '廉江',
                },
                {
                    value: '台山',
                    label: '台山',
                }
            ],
            // 地区
            region: '',
        }
    },
    methods: {
        // 上传课程图片
        httpreq(q) {
            this.$upload(this.address, q).then(res => {

            })
        },
        // 产品详情图片
        httpreq1(q) {
            this.$upload(this.action, q).then(res => {
                this.fileName = res.data.result
                this.image_data = res.data.result;
                this.imgName = '';

            })
        },

        //上传文件的几个方法
        beforeUpload(file) {
            let str = file.name;
            // // console.log(file);
            if (str.substr(str.length - 3, 3).toLocaleLowerCase() != "zip") {
                alert('压缩文件必须是zip格式')
                return false;
            }
        },
        beforeUpload2(file) {
            // // console.log(file);
            const isImage = file.name.replace(/.+\./, "");
            if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG'].indexOf(isImage) == '-1') {
                // // console.log('进入判断')
                this.$message({
                    showClose: true,
                    message: '上传文件类型错误！',
                    type: 'warning'
                })
                return false
            }
        },
        handleRemove(file, fileList) {
            // // console.log(file, fileList);
        },
        handlePreview(file) {
            // // console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        isOk(response, file, fileList) {
            alert(response.msg);
        },
        getYear() {
            let mydate = new Date();
            let year = mydate.getFullYear();
            // // console.log(year)
            for (let i = year; i >= 2018; i--) {
                this.cer_annual.push({ value: i, label: i })
            }
            // // console.log(this.cer_annual)
        },
        getLabel() {
            this.$post('labels/all', { shop_id: this.$store.state.store.id }).then(res => {
                let data = res.data.result;
                // // console.log('所有标签')
                // // console.log(data)
                this.labelsMap = res.data.result;
                this.allLabel(data, this.labels[0]);
                // return true;
            })
        },
        getData() {
            this.fullscreenLoading = true
            let name = '';
            if (this.region !== '') {
                name = this.region;
            }
            if (this.checkList.name !== '') {
                name = this.checkList.name;
            }
            if (this.region !== '' && this.checkList.name !== '') {
                name = this.region + '%' + this.checkList.name;
            }
            this.$post('products/shop_search', {
                offset: this.offset,
                length: this.productLen,
                token: this.$store.state.authority_management,
                shop_id: this.$store.state.store.id,
                teacher: this.checkList.teacher,
                name: name,
                onsale: this.checkList.onsale,
                is_project: 1,
            }).then(res => {
                // // console.log(res.data.result.data)
                this.fullscreenLoading = false
                this.tableData = res.data.result.data;
                // // console.log(this.tableData)
                this.totalProduct = res.data.result.total;
                this.totalPage = Math.ceil(this.totalProduct / this.productLen);
            })
        },
        allLabel(data, labelObj) {
            // // console.log(data,labelObj)
            for (let i in data) {
                // // console.log('label')
                // // console.log(labelObj.id)
                if (data[i].parent_id === labelObj.id) {
                    if (!labelObj.children) {
                        labelObj.children = [];
                    }
                    labelObj.children.push(data[i]);
                    // // console.log(Object.prototype.toString.call(this.labels[0].children),this.labels[0].children)
                    this.allLabel(data, data[i]);
                }
            }
            // // console.log('标签')
            // // console.log(this.labels[0].children)
        },
        //标签选择

        handleChange1(value, form) {
            // // console.log('传入参数')
            // // console.log(value,form);
            // // console.log(this.formCascader)
            let id = value.pop();
            this.formCascader.push(id)
            // // console.log(this.formCascader)
            // // console.log(id)
            //获取父类id
            // this.$post('labels/get_patients',{label_id:id, }).then(res=>{
            //   // // console.log(res)
            // })
            // // console.log(this.labels[0].children)
            // // console.log(this.labelsMap)
            for (let i of this.labelsMap) {
                if (id == i.id) {
                    this.form.label_name = i.name;
                    this.form.label_id = i.id;
                }
            }
        },

        handleSizeChange(val) {
            // // console.log(`每页 ${val} 条`);
            this.productLen = val;
            this.getData();
        },
        handleCurrentChange(val) {
            // // console.log(`当前页: ${val}`);
            this.offset = (val - 1) * this.productLen;
            this.getData();
        },
        selectType(item, index) {//选择课程类型
            // this.page = value;
            // // console.log(item)
            // // console.log(index)
            this.tableData[index].attr = item.label;
        },
        selectItemFrom(item) {
            // // console.log(item)
            this.form.project_id = item.value
        },
        selectTypeFrom(item) {
            this.form.attr = item.label
        },
        selectPage(item, index) {//选择课程页面
            // this.page = value;
            // // console.log(item.label)
            // // console.log(index)
            this.tableData[index].page = item.label;
            // // console.log(this.tableData[index].page)
        },
        selectPageFrom(item) {
            this.form.page = item.label;
            // // console.log(this.form.page)

        },
        // selectCert(item, index) {//选择是否认证
        //   this.tableData[index].is_auth = item.label;
        // },
        selectCertForm() {
        },
        selectCerYear(item, index) {
            this.tableData[index].cer_year = item.label;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            // // console.log(val)
        },
        handleCancle(index, row) {  //取消

            let prevContent = this.prevValue.bookname;
            this.$set(row, "bookname", prevContent);
        },
        addLine(f) { //添加行数
            this.form = {};
            this.creatFlag = f;
            this.dialogFormVisible = true;
        },
        //删除
        handleDelete(index, row) {
            this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('products/shop_delete', { token: this.$store.state.authority_management, id: row.id })
                this.tableData.splice(index, 1);
                this.getData();
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        //上下架
        changeOnsale(index, row) {
            if (row.onsale == 1) {
                row.onsale = 0;
                this.upProduct(index, row);
            }
            else if (row.onsale == 0) {
                row.onsale = 1;
                this.upProduct(index, row);
            }

        },
        //保存
        // save(index,row){
        //   // console.log(row)
        //   // // console.log(JSON.stringify(this.tableData))
        //   this.tableData[index] = row;
        //   // console.log(this.tableData[index])
        //   this.addProduct(index,row)
        // },
        selectRow(val) {
            this.multipleSelection = val
            // // console.log(val)
        },
        //条件查询数据
        searchData() {
            let name = '';
            if (this.region !== '') {
                name = this.region;
            }
            if (this.checkList.name !== '') {
                name = this.checkList.name;
            }
            if (this.region !== '' && this.checkList.name !== '') {
                name = this.region + '%' + this.checkList.name;
            }
            this.$post('products/shop_search', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: this.productLen,
                name: name,
                teacher: this.checkList.teacher,
                onsale: this.checkList.onsale,
                is_auth: this.checkList.is_auth,
                cer_year: this.checkList.cer_year,
                shop_id: this.$store.state.store.id,
                is_project: 1
            }).then(res => {
                // // console.log(res.data.result.data)
                this.tableData = res.data.result.data;
                this.totalProduct = res.data.result.total;
				this.currentPage = 1;
            })

            // // console.log(this.checkList)
        },
        //清除条件
        clearCheckList() {
            this.checkList = { onsale: '', is_auth: '', cer_year: '', teacher: '', name: '', };
            this.getData();
        },
        //模糊查询
        batchDelete() {
            // // console.log(11)
            // // console.log(this.multipleSelection)
            for (let i = 0; i < this.multipleSelection.length; i++) {
                let val = this.multipleSelection[i]
                // // console.log(val)
                for (let j = 0; j < this.tableData.length; j++) {
                    let val1 = this.tableData[j];
                    if (val == val1) {
                        this.tableData.splice(j, 1);
                        // // console.log(this.tableData)
                        break;
                    }
                }

            }
            // 删除完数据之后清除勾选框

        },
        //更新产品
        upProduct(index, val) {
            this.$post('products/edit', {
                name: val.name, desc: val.desc, image: this.image_data, project_id: val.project_id,
                period: val.period,
                teacher: val.teacher,
                teacher_intro: val.teacher_intro,
                onsale: val.onsale,
                attr: val.attr,
                cer_year: val.cer_year,
                cer_industry: val.cer_industry,
                shop_id: this.$store.state.store.id,
                id: val.id,
                price: val.price,
                label_id: val.label_id,
                label_name: val.label_name,
                token: this.$store.state.authority_management
            });
            this.$post('product_labels/edit', { token: this.$store.state.authority_management, label_id: val.label_id, id: this.product_lablel_id, price: val.price, }).then(res => {
                this.$message({
                    showClose: true,
                    message: '产品修改成功',
                    type: 'success'
                });
                this.getData();
            })
            this.dialogFormVisible = false;
        },
        //增加产品
        addProduct(index, val) {
            //插入图片
            this.$post('resources/shop_create', { token: this.$store.state.authority_management, name: val.image, data: this.image_data, price: val.price, type: '5', shop_id: this.$store.state.store.id }).then(res => {
                // // console.log('图片插入返回'),
                // // console.log(res)
            })
            // attr: "选修课"
            // image: "123"
            // is_auth: "0"
            // label_id: "3"
            // label_name: "管理"
            // name: "测"
            // onsale: "0"
            // page: "项目式"
            // period: "123"
            // price: "123"
            // project_id: "60"
            // teacher: "123"
            // teacher_intro: "测name"
            this.$post('products/create_product', {
                name: val.name,
                desc: val.desc,
                image: this.image_data,
                price: val.price,
                project_id: val.project_id,
                period: val.period,
                teacher: val.teacher,
                teacher_intro: val.teacher_intro,
                onsale: val.onsale,
                // is_auth: val.is_auth.value ? val.is_auth.value : '0',
                attr: val.attr,
                cer_year: val.cer_year,
                cer_industry: val.cer_industry,
                shop_id: this.$store.state.store.id,
                label_id: val.label_id,
                token: this.$store.state.authority_management
            }).then(res => {
                this.getData();
            })
            this.dialogTableVisible = false;

        },
        handleEdit1(index, row) {
            this.form = row;
            this.flag = index;
            this.creatFlag = 0;
            this.imgName = row.image;
            // this.formCascader[0].value = row.label_id;
            // this.formCascader[0].label = row.label_name;
            for (let val of this.itemOptions) {
                if (val.value == row.project_id) {
                    this.itemCheck = val.label;
                    break;
                }
            }
            // // console.log('form的值')
            // // console.log(row)
            // // console.log(this.form)
            this.dialogFormVisible = true;
            // // console.log(this.formCascader)
            for (let i of this.labelsMap) {
                if (row.label_id == i.id) {
                    if (this.formCascader.indexOf(i.id) == -1) {
                        this.formCascader.push(i.id)
                    }
                    if (i.parent_id != 0) {
                        this.formCascader.unshift(i.parent_id)
                    }
                    i = i.parent_id
                }
            }
            this.$post('product_labels/listLabels', { offset: 0, length: 1, product_id: row.id }).then(res => {
                // // console.log(res.data.result.data[0].id)
                this.product_lablel_id = res.data.result.data[0].id;
            })
            // // console.log(this.formCascader)
        },
        handleDesc(index, row) {
            this.form = row;
            // // console.log(this.form)
            for (let val of this.itemOptions) {
                if (val.value == row.project_id) {
                    this.project_name = val.label;
                    break;
                }
            }
            this.dialogFormRead = true;
        },

        handleRemove(file, fileList) {
            // // console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.imgName = ''
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 上传成功之后 插入图片名字
        handleAvatarSuccess(res, file) {//图片上传成功
            // // console.log(res);
            // // console.log(file);
            //         {status: "success", result: "2019-05-17-01-24-18.jpg"} 拿到返回的图片名字=》
            // // console.log(res.result);
            // // console.log(this.dialogImageUrl);

        },
        //关闭弹窗
        closeImgDialog() {
            this.$refs['upload'].clearFiles();
            this.dialogFormVisible = false;
        },
        handleSuccess(response) {
            this.fileName = response.result;
            this.image_data = response.result;
            this.imgName = '';
        },
        closeDialog() {
            this.formCascader = [];
            this.form = {};
            this.itemCheck = {}
            this.$refs['upload'].clearFiles()
        },
        //确定保存产品的编辑
        onSubmit() {

            this.$alert('记得配置项目分数噢', '提示', {
                confirmButtonText: '确定'
              })

            //把整个编辑框里面的对象赋值给变量value
            let value = this.form;
            //各种的校验判断
            if (value.name == '' || value.name == undefined) {
                this.$message({
                    showClose: true,
                    message: '产品名称不为空',
                    type: 'error'
                });
            }
            // else if (value.price == '' || value.price == undefined) {
            //   this.$message({
            //     showClose: true,
            //     message: '产品价格不为空',
            //     type: 'error'
            //   });
            // }
            else if (value.teacher == '' || value.teacher == undefined) {
                this.$message({
                    showClose: true,
                    message: '主讲名字不为空',
                    type: 'error'
                });
            }
            // else if (value.price == '' || value.price == undefined) {
            //   this.$message({
            //     showClose: true,
            //     message: '价格不为空',
            //     type: 'error'
            //   });
            // }
            // else if (value.is_auth == '' || value.is_auth == undefined) {
            //   this.$message({
            //     showClose: true,
            //     message: '认证状态不为空',
            //     type: 'error'
            //   });
            // }
            else {
                //creatFlag作为标识判断该操作是增加产品还是修改，因为两者是同一个弹框
                if (this.creatFlag == 1) {
                    this.addProduct(this.flag, this.form)
                } else {
                    this.upProduct(this.flag, this.form);
                }
                this.dialogFormVisible = false;
                this.$refs['upload'].clearFiles();
            }
        },
        //项目式内容
        getItemList() {
            this.$post('projects/shop_search', { token: this.$store.state.authority_management, offset: 0, length: 9999, shop_id: this.$store.state.store.id }).then(res => {
                this.itemList = res.data.result.data;
                let arr = this.itemList.map(res => {
                    let json = {};
                    json.label = res.name;
                    json.value = res.id;
                    return json;
                })
                this.itemOptions = arr
            })
        },
        // 前往分数占比页面
        handleConfig(product) {
            // // console.log(product)

            this.$router.push({
                path: '/percentage',
                query: {
                    product_id: product.id,
                    project_id: product.project_id,
                }
            })
        }
    },
    computed: {
        // tables:function(){
        //   const search = this.search;
        //   // // console.log(12)
        //   if(search){
        //     // // console.log(123)
        //     return  this.tableData.filter(function(dataNews){
        //       return Object.keys(dataNews).some(function(key){
        //         return String(dataNews[key]).toLowerCase().indexOf(search) > -1
        //       })
        //     })
        //   }
        //   return this.tableData
        // }
    },
    mounted: function () {
        // this.getData();
    },
    created: function () {
        this.getData();
        this.getLabel();
        this.getYear();
        this.getItemList();
    }
}
